import { createTheme } from "@mui/material/styles";

import DMSANTTF from "./assets/fonts/dm-sans-v11-latin-regular.ttf";

export const theme = createTheme({
  constants: {
    containerWidth: "44.25rem",
    conventionalColor: "var(--primary-500, #FF2E00)",
    eliteColor: "var(--colour-text-text_accent, #220600)",
    islamicColor: "var(--colour-text-text_islamic, #013315)"
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1280,
      lg: 1440,
      xl: 1920
    }
  },
  typography: {
    fontFamily: "Rakbank Sans"
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": {
          fontFamily: "Rakbank Sans",
          src: `url(${DMSANTTF}) format("truetype")`
        }
      }
    }
  },
  transitions: {
    duration: 0.3
  },
  palette: {
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#517085"
    },
    action: {
      disabledBackground: "#d3d8db"
    },
    button: {
      color: "#263d4c",
      backgroundColor: "#ffffff"
    },
    text: {
      color: "#000000"
    },
    header: {
      backgroundColor: "var(--colour-text-text_accent, #220600)"
    }
  }
});
